import { FC, ReactNode, useEffect } from 'react';

import { Footer, UserCentric } from '@catawiki/layout';

import { isInMobileApp } from '@/shared/utils/isInMobileApp';

import { LocalAssets } from '../api/assets';
import { isInBuilder } from '../utils/isInBuilder';
import { HeadTag, Header, HeaderSettings, JsTag } from './assets';

interface Props extends HeaderSettings {
  assetsData?: LocalAssets;
  children: ReactNode;
}

export const Layout: FC<Props> = ({
  assetsData,
  theme,
  partnershipLogo,
  stickyHeader,
  children,
}) => {
  const inApp = isInMobileApp();
  const insideBuilder = isInBuilder();

  useEffect(() => {
    if (inApp) {
      document.body.classList.remove('tw:header-offset');
    }
  }, [inApp]);

  if (!assetsData) return <div>{children}</div>;

  return (
    <div className="u-typography-body">
      <HeadTag assetsData={assetsData} />
      {inApp ? null : (
        <Header
          assetsData={assetsData}
          theme={theme}
          partnershipLogo={partnershipLogo}
          stickyHeader={stickyHeader}
        />
      )}
      {children}
      {inApp ? null : <Footer />}
      {inApp || insideBuilder ? null : <UserCentric />}
      <JsTag assetsData={assetsData} />
    </div>
  );
};
